// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-jubilarfeier-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzJubilarfeier2DE: PageEntry = {
  id: "post.dietz-jubilarfeier-2",
  locale: "de",
  slug: "dietz-jubilarfeier-2",
  seo: {
    title: "Nachbericht Hightech live! Projekttag | Dietz GmbH",
    description: "Nachbericht Hightech live! Projekttag",
  },
  type: "post",
  h1: "Nachbericht Hightech live! Projekttag",
  blocks: [
    { kind: "heading", level: 2, text: "Nachbericht Hightech live! Projekttag" },
    { kind: "paragraph", text: "Am 17.11.2021 war es so weit und wir waren Gastgeber beim Hightech live! Projekttag. Der Projekttag der Bildungsinitiative Technik-Zukunft in Bayern 4.0 wird gefördert von den bayrischen Metall- und Elektroarbeitgeberverbänden bayme vbm und dem bayrischen Wirtschaftsministerium." },
    { kind: "paragraph", text: "Im Rahmen des Projekttags ging es darum Schülerinnen und Schülern der 8. und 9. Jahrgangsstufe aus Neustadt und Umgebung einen Einblick in unser Unternehmen und die Vielzahl an technischen Ausbildungsberufen zu geben." },
    { kind: "paragraph", text: "Neben diesem Einblick konnten sich die Teilnehmer beim Bau einer Handbügelsäge auch praktisch ausprobieren und bekamen Tipps & Tricks für ihre Bewerbung." },
    { kind: "paragraph", text: "Wir freuen uns sehr, dass wir Teil dieses tollen Projekts sein konnten." },
    { kind: "paragraph", text: "Zum offiziellen Pressebericht." }
  ],
};
